/**
 * Adresse de l'API — source unique.
 *
 * Six fichiers calculaient cette adresse chacun de leur cote, avec quatre
 * valeurs de repli differentes ('http://localhost:8000', '.../api', '/api/v1',
 * chaine vide) et, dans un cas, sans ajouter le segment de version. Le flux
 * temps reel du back-office pointait ainsi sur /api/admin/sse au lieu de
 * /api/v1/admin/sse et repondait 404 en boucle.
 *
 * VITE_API_URL contient la racine de l'API, segment /api inclus et sans
 * version (ex. https://abbusinessgn.com/api). La version est ajoutee ici,
 * une seule fois.
 */

/** Racine de l'API, sans numero de version. */
export const API_ORIGIN = import.meta.env.VITE_API_URL ?? 'http://localhost:8000/api'

/** Point d'entree versionne : tout appel applicatif part d'ici. */
export const API_BASE = `${API_ORIGIN}/v1`
